module.exports = __webpack_public_path__ + "static/media/22792342_1629547983787053_1714419343087681747_o.9885dd8b.jpg";